import { Route } from "react-router-dom";
import PageTitle from "../components/PageTitle";
import ProtectedRouteV2 from "./ProtectedRouteV2";
import AboutSystem from "../pages/About/AboutSystem";
import AboutMission from "../pages/About/AboutMission";
import AboutFaq from "../pages/About/AboutFaq";
import AboutTerms from "../pages/About/AboutTerms";
import AboutPrivacy from "../pages/About/AboutPrivacy";
import AboutContact from "../pages/About/AboutContact";

/**
 * 🧭 aboutRoutes
 *
 * Rutas protegidas del módulo "Acerca de Codenova".
 * - Alineadas con el backend (`AboutMenuBuilder`).
 * - Todas las vistas son públicas para cualquier rol autenticado.
 */
const aboutRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    {/* 🔹 Sobre el sistema */}
    <Route
      path="/about/system"
      element={
        <>
          <PageTitle title="Sobre el Sistema | Codenova POS" />
          <AboutSystem />
        </>
      }
    />

    {/* 🔹 Misión y Visión */}
    <Route
      path="/about/mission"
      element={
        <>
          <PageTitle title="Misión y Visión | Codenova POS" />
          <AboutMission />
        </>
      }
    />

    {/* 🔹 Preguntas frecuentes */}
    <Route
      path="/about/faq"
      element={
        <>
          <PageTitle title="Preguntas Frecuentes | Codenova POS" />
          <AboutFaq />
        </>
      }
    />

    {/* 🔹 Términos y Condiciones */}
    <Route
      path="/about/terms"
      element={
        <>
          <PageTitle title="Términos y Condiciones | Codenova POS" />
          <AboutTerms />
        </>
      }
    />

    {/* 🔹 Política de Privacidad */}
    <Route
      path="/about/privacy"
      element={
        <>
          <PageTitle title="Política de Privacidad | Codenova POS" />
          <AboutPrivacy />
        </>
      }
    />

    {/* 🔹 Soporte y Contacto */}
    <Route
      path="/about/contact"
      element={
        <>
          <PageTitle title="Soporte y Contacto | Codenova POS" />
          <AboutContact />
        </>
      }
    />
  </Route>
);

export default aboutRoutes;
